module.exports = require('./helpers/bundle-url').getBundleURL('8kqgc') + "card-faq.e92741d9.png";